



import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyDbPzqqVkzuGT04f9STYuG_hOUkqGESpKo",
  authDomain: "optica-international-web.firebaseapp.com",
  projectId: "optica-international-web",
  storageBucket: "optica-international-web.firebasestorage.app",
  messagingSenderId: "794759801248",
  appId: "1:794759801248:web:6d939dbc044f3e126f1cc5"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export























